<template>
    <v-container fluid grid-list-sm>
        <v-form ref="form_devolucion">
            <v-row dense>
                <v-col cols="12">
                    <ModalInformacionComponent :titulo="obModal.titulo" :open="obModal.open" :descripcion="obModal.descripcion"/>
                </v-col>
            </v-row>
            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="6">
                    <v-radio-group v-model="obForm.idTipoDevolucion" row dense>
                        <v-radio v-for="(v,k) in listTipoDevolucion" color="primary" :key="k" :value="v.idTipoVenciCis"
                            :label="v.tipoVenciCis"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row v-show="disabled" align="center" justify="center">
                <v-col cols="12" sm="6">
                    <v-text-field label="Nombre *" color="textbox" v-model="nombreCliente" disabled outlined dense />
                </v-col>
            </v-row>
            <v-row v-show="disabled" align="center" justify="center">
                <v-col cols="12" sm="6">
                    <v-autocomplete label="Institución Financiera *" color="textbox"
                        v-model="obForm.idInstitucionFinaciera" :items="listInstitucionFinanciera"
                        item-text="institucion" item-value="idInstitucionFinanciera"
                        :rules="disabled ? requeridoRegla : []" outlined dense />
                </v-col>
            </v-row>
            <v-row v-show="disabled" align="center" justify="center">
                <v-col cols="12" sm="6">
                    <v-text-field label="No. Cuenta *" color="textbox" v-model="obForm.nroCuenta"
                        :rules="disabled ? _.concat(requeridoRegla,soloNumerosRegla(5,_.isNull(obForm.nroCuenta) ? 0 : obForm.nroCuenta,20)) : []"
                        outlined dense />
                </v-col>
            </v-row>
            <v-row v-show="disabled" align="center" justify="center">
                <v-col cols="12" sm="6">
                    <v-autocomplete label="Tipo de Cuenta *" color="textbox" v-model="obForm.idTipoCuenta"
                        :items="listTipoCuenta" item-text="cuenta" item-value="idTipoCuenta"
                        :rules="disabled ? requeridoRegla : []" outlined dense />
                </v-col>
            </v-row>
            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="1">
                    <v-checkbox color="primary" v-model="aceptacion" dense/>
                </v-col>
                <v-col cols="11" sm="5">
                    <p style="color: #000;margin-top: 21px;margin-bottom: 21px;">
                        Declaro que he leído y aceptado los <a id="termino" style="color:#EE4637" @click="verDetalle"> Términos y Condiciones.</a>
                    </p>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
    export default {
        name: 'StepperFormaDevolucionComponent',
        props:{
            load:{
                type: Boolean,
                default: false
            },
            nombreCliente:{
                type: String,
                default: ''
            },
            listTipoDevolucion:{
                type: Array,
                default: []
            },
            listInstitucionFinanciera:{
                type: Array,
                default:[]
            },
            listTipoCuenta:{
                type: Array,
                default:[]
            },
            parametros:{
                type: Object,
                default:{}
            },
            textoTerminoCondicionExclusion:{
                type:String,
                default:''
            }
        },
        data: () => ({
            obForm:{
                idTipoDevolucion: null,
                idInstitucionFinaciera: null,
                nroCuenta: null,
                idTipoCuenta: null,
            },
            obModal:{
                    titulo:'',
                    open:false,
                    descripcion:''
                },
            aceptacion: false
        }),
        components:{
            ModalInformacionComponent: () => import('@/components/utilites/ModalInformacionComponent.vue')
        },
        watch:{
            load(val){
                if(val){
                    this.obForm.idTipoDevolucion = this.listTipoDevolucion[0].idTipoVenciCis;
                    this.obForm.idInstitucionFinaciera = this.listInstitucionFinanciera[0].idInstitucionFinanciera;
                    this.obForm.idTipoCuenta = this.listTipoCuenta[0].idTipoCuenta;
                }
            }
        },
        computed:{
            disabled(){
                return _.toNumber(_.get(this.obForm,'idTipoDevolucion',0)) != this.parametros.id_tipo_devolucion_cheque ? true : false;
            }
        },
        methods:{
            validacion(){
                 try {
                        if(!this.$refs.form_devolucion.validate()) throw mensajeEstandar.corregirInformacion;
                        if(!this.aceptacion) throw 'Debe aceptar los términos de Exclusión.';
                            return true;
                    } catch (error) {
                        mensajesAlerta(error,'I');
                        return false;
                    }
            },
            verDetalle(){
                this.obModal = {
                    titulo: 'Términos y Condiciones de Uso de Sitio Web',
                    descripcion: this.textoTerminoCondicionExclusion,
                    open: true
                };
            },
            close(){
                this.obModal = {
                    titulo:'Términos y Condiciones de Uso de Sitio Web',
                    open: false,
                    descripcion:this.textoTerminoCondicionExclusion
                };
            },
        },
        provide(){
            return{
                close: this.close
            }
        }
    }
</script>
<style>
    #termino:hover{
        text-decoration: underline;
    }
    #termino:active {
    text-decoration: underline;
    }
</style>